import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import SessionManager from "../../../../utils/sessionManager";
import { showAccessDeniedAlert } from "../../../../utils/accessDenied";
import { showTokenExpiredAlert } from "../../../../utils/alert";

export const constructionStageList = createAsyncThunk('constructionStageList', async ({ pageable: data, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + 'construction-stage',
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const constructionStageListSlice = createSlice({
    name: 'constructionStageList',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(constructionStageList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                const payloadData = action.payload.data.data;
                state.data = Array.isArray(payloadData) ? payloadData : payloadData?.rows ?? [];
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }

        });
        builder.addCase(constructionStageList.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default constructionStageListSlice.reducer;
